import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Grid, Button, MenuItem, Box, Stack, Alert
} from "@mui/material";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API;

const EMPTY = {
  template_key: "t1",
  name: "",
  title: "",
  subtitle: "",
  subtitle_2: "",
  description: "",
  description_2: "",
  info: "",
  info_2: "",
  image_url: "",
  image_url_2: "",
  // novos campos
  link_url: "",
  link_url_2: "",
  link_tag: "",
  link_tag_2: "",
};

export default function AnnouncementDialog({
  open,
  setOpen,
  editing = false,
  values,
  setValues,
  onChanged,
}) {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    setError("");
    if (open) {
      if (editing && values?.id) {
        if (values.name || values.template_key) {
          setForm({ ...EMPTY, ...values });
        } else {
          (async () => {
            try {
              setLoading(true);
              const { data } = await axios.get(`${API_BASE}/announcements/${values.id}`);
              if (mounted) setForm({ ...EMPTY, ...data });
            } catch (e) {
              console.error("GET /announcements/:id failed", e);
              if (mounted) setError("Falha ao carregar o anúncio.");
            } finally {
              setLoading(false);
            }
          })();
        }
      } else {
        setForm(EMPTY);
      }
    }
    return () => (mounted = false);
  }, [open, editing, values]);

  const handleClose = () => {
    setOpen(false);
    setError("");
    setForm(EMPTY);
    setValues?.(null);
  };

  const handleChange = (field) => (e) => {
    setForm((f) => ({ ...f, [field]: e.target.value }));
  };

  const handleSubmit = async () => {
    setError("");
    if (!form.name?.trim()) return setError("O nome é obrigatório.");
    if (!form.template_key?.trim()) return setError("O template é obrigatório.");

    try {
      setLoading(true);
      if (editing && values?.id) {
        await axios.put(`${API_BASE}/announcements/${values.id}`, form);
      } else {
        await axios.post(`${API_BASE}/announcements`, form);
      }
      onChanged?.();
      handleClose();
    } catch (e) {
      console.error("save announcement failed", e);
      setError("Não foi possível salvar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>{editing ? "Editar anúncio" : "Novo anúncio"}</DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}

          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                select
                fullWidth
                label="Template (obrigatório)"
                value={form.template_key}
                onChange={handleChange("template_key")}
              >
                <MenuItem value="t1">T1</MenuItem>
                <MenuItem value="t2">T2</MenuItem>
                <MenuItem value="t3">T3</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label="Nome do anúncio (obrigatório)"
                value={form.name}
                onChange={handleChange("name")}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Título"
                value={form.title}
                onChange={handleChange("title")}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Subtítulo"
                value={form.subtitle}
                onChange={handleChange("subtitle")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Subtítulo 2"
                value={form.subtitle_2}
                onChange={handleChange("subtitle_2")}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                label="Descrição"
                value={form.description}
                onChange={handleChange("description")}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                label="Descrição 2"
                value={form.description_2}
                onChange={handleChange("description_2")}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Info"
                value={form.info}
                onChange={handleChange("info")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Info 2"
                value={form.info_2}
                onChange={handleChange("info_2")}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Imagem URL"
                value={form.image_url}
                onChange={handleChange("image_url")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Imagem URL 2"
                value={form.image_url_2}
                onChange={handleChange("image_url_2")}
              />
            </Grid>

            {/* ===== novos campos: links ===== */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Link URL"
                placeholder="https://..."
                value={form.link_url}
                onChange={handleChange("link_url")}
                type="url"
                inputMode="url"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Rótulo do Link"
                placeholder="Ex.: Saiba mais"
                value={form.link_tag}
                onChange={handleChange("link_tag")}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Link URL 2"
                placeholder="https://..."
                value={form.link_url_2}
                onChange={handleChange("link_url_2")}
                type="url"
                inputMode="url"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Rótulo do Link 2"
                placeholder="Ex.: Ver planos"
                value={form.link_tag_2}
                onChange={handleChange("link_tag_2")}
              />
            </Grid>
          </Grid>

          {/* Preview leve opcional */}
          {(form.image_url || form.image_url_2) && (
            <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
              {form.image_url && (
                <Box
                  component="img"
                  src={form.image_url}
                  alt=""
                  sx={{ width: 160, height: 100, objectFit: "cover", borderRadius: 1, boxShadow: 1 }}
                />
              )}
              {form.image_url_2 && (
                <Box
                  component="img"
                  src={form.image_url_2}
                  alt=""
                  sx={{ width: 160, height: 100, objectFit: "cover", borderRadius: 1, boxShadow: 1 }}
                />
              )}
            </Box>
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="inherit">Cancelar</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {editing ? "Salvar alterações" : "Criar anúncio"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
